import { render, staticRenderFns } from "./Sifter.vue?vue&type=template&id=5104e0fd&scoped=true"
import script from "./Sifter.vue?vue&type=script&lang=js"
export * from "./Sifter.vue?vue&type=script&lang=js"
import style0 from "./Sifter.vue?vue&type=style&index=0&id=5104e0fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104e0fd",
  null
  
)

export default component.exports